import React, {useState} from "react";
import {Box, Button, Typography} from "@material-ui/core/";
import Link from "next/link";
import {makeStyles} from "@material-ui/core/styles";
import {useRouter} from 'next/router'
import {observer} from "mobx-react-lite";
import {apiRequest} from "../util/util";
import sessionInfo from "../util/sessionInfo";
import {useAuth} from "../util/auth";
import StoryCard from "../components/StoryCard";
import Meta from "../components/Meta";
import PlaceHolderStoryCard from "../components/PlaceHolderStoryCard";
import {story, Story} from "../utils/story";
import {StorySection} from "../utils/storySection";
import {UserInputCard} from "../components/userInputCard";
import track from "../util/frontend_analytics";
import {isClaimed, takeReturn} from "../util/authReturn";
import StoryCast from "../components/StoryCast";
// do not delete this line or you will get tsx compile error
declare global {
    interface Window {
        analytics: any;
    }
}
const useStyles = makeStyles((theme) => ({
    page: {
        paddingTop: theme.spacing(3.5),
        [theme.breakpoints.down("xs")]: {
            paddingTop: theme.spacing(2.5),
        },
    },
    column: {
        maxWidth: 680,
        margin: "0 auto",
        padding: theme.spacing(0, 3),
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(0, 2.5),
        },
    },
    header: {
        textAlign: "center",
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down("xs")]: {
            marginBottom: theme.spacing(2.5),
        },
    },
    title: {
        fontSize: "2.25rem",
        lineHeight: 1.15,
        overflowWrap: "break-word",
        [theme.breakpoints.down("xs")]: {
            fontSize: "1.75rem",
        },
    },
    subtitle: {
        marginTop: theme.spacing(1),
        color: theme.palette.text.secondary,
        fontSize: "1rem",
        lineHeight: 1.5,
    },
    ornament: {
        marginTop: theme.spacing(1.5),
        color: theme.palette.primary.main,
        letterSpacing: "0.6em",
        fontSize: "0.8rem",
        "&::after": {
            content: '"\\2726  \\2726  \\2726"',
        },
    },
    end: {
        textAlign: "center",
        padding: theme.spacing(6, 2, 10),
        borderTop: `1px solid ${theme.palette.divider}`,
        maxWidth: 680,
        margin: theme.spacing(4, "auto", 0),
    },
    endTitle: {
        marginBottom: theme.spacing(2.5),
    },
}));

export const StoryInputView = observer(({story, readOnly}: { story: Story, readOnly: boolean }) => {
    const classes = useStyles();
    console.log('story id', story.id)
    console.log('story section length', story.sections.length)
    console.log('input readonly', readOnly)

    return <Box>
        {(!readOnly || (story.id === undefined) || story.sections.length === 1) ? <UserInputCard waitingUser={true}/> :
            <Box className={classes.end}>
                <Typography variant="h5" component="p" className={classes.endTitle}>Want a story of your own?</Typography>
                <Link href="/" passHref>
                    <Button component="a" variant="contained" color="primary" size="large">Start one now</Button>
                </Link>
            </Box>}
    </Box>

})

export const StoryView = observer(({story, readOnly, loading}: { story: Story, readOnly: boolean, loading: boolean }) => {
    // user react memo to only re-render when the story changes
    const finalNotReadOnly = (!readOnly || (story.id === undefined) || story.sections.length === 1)
    const finalReadOnly = !finalNotReadOnly
    console.log('final read only', readOnly)


    const storyRender = <div>
        {loading && story.sections.length === 0 && !story.processing &&
            <PlaceHolderStoryCard label="Opening your story" withImage/>}
        <div>
                {story.sections.map((section: StorySection, index: number) =>
                    <StoryCard
                        key={index}
                        text={section.text}
                        image={section.image}
                        picture={section.picture}
                        id={section.id}
                        lastCard={index === story.sections.length - 1}
                        readOnly={finalReadOnly}
                        firstCard={index === 0}
                        endOfStory={section.endOfStory}
                        storyId={story.id}
                        storySection={section}
                        userText={section.userText}
                    />)}
        </div>
        {story.processing && <PlaceHolderStoryCard/>}
    </div>

    return (storyRender)
})


const HOME_TITLE = "MyTales - Interactive Erotic Stories with AI"
const HOME_DESCRIPTION = "Interactive erotic stories written with AI. Pick a fantasy or write your own, and decide what happens next. For adults 18+."
const HOME_SUBTITLE = "Interactive erotic stories written with AI. You decide what happens next."

function Index({
                   storyId,
                   description,
                   title,
                   firstSection,
                   openerId
               }: {
    storyId?: string,
    description?: string,
    title?: string
    firstSection?: StorySection
    openerId?: string
}) {
    console.log('storyid', story.id)
    const [finalTitle, setFinalTitle] = useState(title)
    const fetchedStoryId = storyId;
    const router = useRouter()
    const auth = useAuth()
    const classes = useStyles()


    var {theme, editable} = router.query as { theme: string, editable: string }
    const themeMapping: any = {
        'erotica': 'Erotica',
        'romance': 'Romance',
        'scifi': 'SciFi',
        'got': 'GoT',
        'Landing Page Theme': '',
    }
    var titleText = `MyTales - ${themeMapping[theme]}`
    // the home page starts an erotic story, the genre people come and pay for
    const isHome = router.pathname === "/"
    if (theme === undefined) {
        theme = "erotica"
        titleText = "MyTales"
    }
    var tags;
    var customErotica = false;
    if (theme === "eroticaCustom") {
        tags = ['random', 'straight', 'gay male', 'lesbian', 'college',
            'domination', 'submissive', 'older man', 'older woman', 'taboo', 'cuckold']
        customErotica = true
    }
    sessionInfo.setHome(router.route)

    const [readOnly, setReadOnly] = useState(editable !== 'true')
    // as soon as auth is done, check if the story is owned by the current user
    // if not, set readOnly to true, else set to false
    // make this into an effect predicated on auth
    React.useEffect(() => {

        // if (story.sections.length < 2){
        //     setReadOnly(false)
        //     return
        // }
        if (isClaimed(storyId)) {
            setReadOnly(false)
            return
        }
        if (auth.user !== undefined && auth.user !== false && auth.user !== null) {
            console.log('verified ownership!')
            // @ts-ignore
            apiRequest('get-is-story-owned',
                'POST',
                {
                    userId: auth.user.uid,
                    storyId: storyId
                }).then((res) => {

                // check if code is 200
                debugger
                if (res) {

                    console.log('mineee')
                    setReadOnly(false)

                } else {
                    console.log('not mine')
                    setReadOnly(true)
                }
            })
        }

    }, [auth, storyId])


    // when compomnent first mounts, query for a story opener
    // @ts-ignore
    async function genStory() {
        console.log('auth', auth)
        const resJson = await apiRequest('ml', 'POST', {target: 'write', newStory: true, theme: theme})
        track("story_new", {
            theme: theme,
            branch: process.env.BRANCH
        })
        story.setId(resJson.sessionId)
        story.setTheme(theme as string)
        story.setOwned(true)
        setReadOnly(false)
        console.log('storyId is', story.id)
        console.log('story theme is', story.theme)
        const storySection = new StorySection(
            resJson.sectionId,
            resJson.text,
            resJson.imgUrl,
            [resJson.imgUrl],
            resJson.endOfStory,
            resJson.userText,
            resJson.picture
        )
        await story.addSection(storySection)
    }

    async function fetchStory(fetchedStoryId: string) {
        try {
            const res = await apiRequest('ml', 'POST', {target: 'get-story', sessionId: fetchedStoryId})
            story.clear()
            story.setId(fetchedStoryId)
            story.setCharacters(res.characters)
            setFinalTitle(res.title)
            const sections = res.story;
            for (const section of sections) {
                await story.addSection(new StorySection(
                    section.sectionId,
                    section.text,
                    section.imgUrl,
                    [section.imgUrl],
                    section.endOfStory,
                    section.userText,
                    section.picture
                ))
            }
            story.watchPictures()
        } catch (e) {
            console.log('could not fetch story')
            console.log(e)
            genStory()
            router.push('/')
        }
    }

    React.useEffect(() => {
        // wait until the address (and its ?theme=) has been read, so a new story gets the right genre
        if (!router.isReady) {
            return
        }
        // back from signing up with Google mid-story: go back to that story instead of starting a new one
        const returnStoryId = takeReturn()
        if (returnStoryId && returnStoryId !== fetchedStoryId) {
            router.replace(`/story/${returnStoryId}?editable=true`)
            return
        }
        const handleStoryLifecycle = async () => {
            story.clear()
            if (firstSection) {
                const storySectionObj = StorySection.fromJson(firstSection)
                await story.addSection(storySectionObj)
                story.setTheme("erotica")
                // get storyId from the optional storyId
                console.assert(storyId !== undefined)
                if (storyId !== undefined) {
                    story.setId(storyId)
                }
                const res = await apiRequest('ml', 'POST', {
                    target: 'write',
                    openerId: openerId,
                    theme: 'erotica',
                    openerOnly: true,
                    newStory: true
                });
                console.log('session id is', res.sessionId)
                story.setId(res.sessionId)
                story.setOwned(true)
                setReadOnly(false)
            } else if (fetchedStoryId === undefined) {
                console.log('customErotica', customErotica)
                if (story.sections.length === 0 && !customErotica) {
                    await genStory()
                    console.log('done')
                }
            } else {
                console.log('fetching story id', fetchedStoryId)
                await fetchStory(fetchedStoryId)
            }
        };

        handleStoryLifecycle();

        // Cleanup logic, if necessary, can go here
        return () => {
            // Perform cleanup
        };
    }, [fetchedStoryId, firstSection, openerId, router.isReady]); // Add all dependencies here


    return (
        <Box>
            <Meta description={description || (isHome ? HOME_DESCRIPTION : undefined)}
                  title={finalTitle || (isHome ? HOME_TITLE : undefined)}
            />
            <Box className={classes.page}>
                <Box className={classes.column}>
                    <header className={classes.header}>
                        <Typography variant={'h3'} component={'h1'} className={classes.title}
                                    align={'center'}>{finalTitle ? finalTitle : titleText}</Typography>
                        {isHome && !finalTitle &&
                            <Typography variant={'subtitle1'} align={'center'}
                                        className={classes.subtitle}>{HOME_SUBTITLE}</Typography>}
                        <div className={classes.ornament} aria-hidden="true"/>
                    </header>
                    <StoryCast story={story}/>
                    <StoryView story={story} readOnly={readOnly} loading={!customErotica}/>
                </Box>
                <StoryInputView story={story} readOnly={readOnly}/>
            </Box>
            <div
                style={{display: "none"}}
            >
                <a href={"https://theresanaiforthat.com/ai/mytales/?ref=featured&v=4377"}
                   target={"_blank"}
                   rel={"nofollow"}

                >
                    <img width={"300"} src={"https://media.theresanaiforthat.com/featured-on-taaft.png?width=600"}/>
                </a>
            </div>

        </Box>)
}


export default Index
// export story as a global variable
